import React from "react";

import { Button } from "../../../components/Field";
import { getIcon } from "../../../helpers/icons";
import Text from "../../../components/Text";
import Title from "../../../components/Title";
import Spacer from "../../../components/Spacer";
import Section from "../../../components/Section";
import Background from "../../../components/Background";

import style from "./style.module.css";

export default function SiteMap(props) {
    const {
        map_url = "",
        desc = "",
        image_pic,
        title = "",
        sub_title = "",
        button_url = "",
        button_label = "",
        content_type = "",
    } = props;

    return (
        <Section className={style.siteMap}>
            <div className={style.siteMapWrap}>
                {
                    title !== "" && (
                        <div className={content_type === "image" ? style.imageTitle : style.mapTitle}>
                            <Title
                                transform="uppercase"
                                tag="h1"
                                className="fontTeko"
                            >
                                {title}
                            </Title>
                            <Spacer size="24" />
                        </div>
                    )
                }
                <div className={content_type === "image" ? style.siteImageSection : style.siteMapSection}>
                    <div className={style.col1}>
                        <div className={style.icon}>
                            <i className={getIcon(content_type === "image" ? "Map" : "Location")}></i>
                        </div>
                        <div className={style.textItems}>
                            {
                                sub_title !== "" && (
                                    <Title 
                                        transform="uppercase" 
                                        tag="h2" 
                                        className="fontTeko"
                                    >
                                        {sub_title}
                                    </Title>
                                )
                            }
                            {
                                desc !== "" && (
                                    <div className={style.subText}>
                                        <Text text={desc} />
                                    </div>
                                )
                            }
                        </div>
                        {
                            button_label !== "" && button_url !== "" && (
                                <Button 
                                    link={button_url.name} 
                                    color="buttonPrimary" 
                                    label={button_label} 
                                />
                            )
                        }
                    </div>
                    <div className={style.col2}>
                        {
                            content_type === "image" && (
                                <div className={style.mapImagewarp}>
                                    <Background src={image_pic} size="796x640" cPosition="bottomRight" />
                                </div>
                            )
                        }
                        {
                            content_type === "map" && (
                                <div className={style.mapImagewarp}>
                                    <iframe
                                        width="100%"
                                        height="100%"
                                        src={map_url}
                                        title="Map Display"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </Section>
    )
}